import 'bootstrap/js/modal';
import Swiper from 'swiper/dist/js/swiper';

(function publicUniversities() {
  const $nearbyUniversitiesCards = $('.js-nearby-universities-cards');
  const $publicCampusSelect2 = $('.js-fetch-public-campus');
  const universitySlug = $('.js-university-slug').val();

  function initUniversitiesSwiper() {
    new Swiper('.js-nearby-universities-swiper', { // eslint-disable-line
      spaceBetween: 30,
      slidesPerView: 4,
      simulateTouch: false,
      breakpoints: {
        992: {
          spaceBetween: 15,
          slidesPerView: 'auto',
          freeMode: false,
          pagination: {
            el: '.js-nearby-universities-swiper-pagination',
            clickable: true,
          },
        },
      },
    });
  }
  initUniversitiesSwiper();

  if ($nearbyUniversitiesCards.length > 0) {
    $publicCampusSelect2.on('select2:select', function findNearbyUniversities() {
      $.ajax({
        url: '/nearby_universities',
        method: 'GET',
        data: {
          emec_campus_id: $(this).val(),
          university_id: universitySlug,
        },
        success() {
          initUniversitiesSwiper();
        },
      });
    });
  }

  _require(['jquery/perfect-scrollbar'], () => {
    $('.js-student-evaluation-box__content-wrapper').perfectScrollbar();
  });
}());
